import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Phone, ChevronDown, AlertCircle } from 'lucide-react';
import { FLAG_COMPONENTS } from '../../utils/flagLoader';

// Liste complète de tous les pays avec codes téléphoniques et ISO, triée par ordre alphabétique
const ALL_COUNTRIES = [
  { code: '+93', country: 'AF', name: 'Afghanistan' },
  { code: '+27', country: 'ZA', name: 'Afrique du Sud' },
  { code: '+355', country: 'AL', name: 'Albanie' },
  { code: '+213', country: 'DZ', name: 'Algérie' },
  { code: '+49', country: 'DE', name: 'Allemagne' },
  { code: '+376', country: 'AD', name: 'Andorre' },
  { code: '+244', country: 'AO', name: 'Angola' },
  { code: '+1268', country: 'AG', name: 'Antigua-et-Barbuda' },
  { code: '+966', country: 'SA', name: 'Arabie saoudite' },
  { code: '+54', country: 'AR', name: 'Argentine' },
  { code: '+374', country: 'AM', name: 'Arménie' },
  { code: '+61', country: 'AU', name: 'Australie' },
  { code: '+43', country: 'AT', name: 'Autriche' },
  { code: '+994', country: 'AZ', name: 'Azerbaïdjan' },
  { code: '+1242', country: 'BS', name: 'Bahamas' },
  { code: '+973', country: 'BH', name: 'Bahreïn' },
  { code: '+880', country: 'BD', name: 'Bangladesh' },
  { code: '+1246', country: 'BB', name: 'Barbade' },
  { code: '+32', country: 'BE', name: 'Belgique' },
  { code: '+501', country: 'BZ', name: 'Belize' },
  { code: '+229', country: 'BJ', name: 'Bénin' },
  { code: '+975', country: 'BT', name: 'Bhoutan' },
  { code: '+375', country: 'BY', name: 'Biélorussie' },
  { code: '+591', country: 'BO', name: 'Bolivie' },
  { code: '+387', country: 'BA', name: 'Bosnie-Herzégovine' },
  { code: '+267', country: 'BW', name: 'Botswana' },
  { code: '+55', country: 'BR', name: 'Brésil' },
  { code: '+673', country: 'BN', name: 'Brunei' },
  { code: '+359', country: 'BG', name: 'Bulgarie' },
  { code: '+226', country: 'BF', name: 'Burkina Faso' },
  { code: '+257', country: 'BI', name: 'Burundi' },
  { code: '+855', country: 'KH', name: 'Cambodge' },
  { code: '+237', country: 'CM', name: 'Cameroun' },
  { code: '+1', country: 'CA', name: 'Canada' },
  { code: '+238', country: 'CV', name: 'Cap-Vert' },
  { code: '+236', country: 'CF', name: 'République centrafricaine' },
  { code: '+235', country: 'TD', name: 'Tchad' },
  { code: '+56', country: 'CL', name: 'Chili' },
  { code: '+86', country: 'CN', name: 'Chine' },
  { code: '+57', country: 'CO', name: 'Colombie' },
  { code: '+269', country: 'KM', name: 'Comores' },
  { code: '+242', country: 'CG', name: 'Congo' },
  { code: '+243', country: 'CD', name: 'République démocratique du Congo' },
  { code: '+850', country: 'KP', name: 'Corée du Nord' },
  { code: '+82', country: 'KR', name: 'Corée du Sud' },
  { code: '+506', country: 'CR', name: 'Costa Rica' },
  { code: '+225', country: 'CI', name: 'Côte d\'Ivoire' },
  { code: '+385', country: 'HR', name: 'Croatie' },
  { code: '+53', country: 'CU', name: 'Cuba' },
  { code: '+357', country: 'CY', name: 'Chypre' },
  { code: '+420', country: 'CZ', name: 'Tchéquie' },
  { code: '+45', country: 'DK', name: 'Danemark' },
  { code: '+253', country: 'DJ', name: 'Djibouti' },
  { code: '+1767', country: 'DM', name: 'Dominique' },
  { code: '+20', country: 'EG', name: 'Égypte' },
  { code: '+971', country: 'AE', name: 'Émirats arabes unis' },
  { code: '+593', country: 'EC', name: 'Équateur' },
  { code: '+291', country: 'ER', name: 'Érythrée' },
  { code: '+34', country: 'ES', name: 'Espagne' },
  { code: '+372', country: 'EE', name: 'Estonie' },
  { code: '+268', country: 'SZ', name: 'Eswatini' },
  { code: '+1', country: 'US', name: 'États-Unis' },
  { code: '+251', country: 'ET', name: 'Éthiopie' },
  { code: '+679', country: 'FJ', name: 'Fidji' },
  { code: '+358', country: 'FI', name: 'Finlande' },
  { code: '+33', country: 'FR', name: 'France' },
  { code: '+241', country: 'GA', name: 'Gabon' },
  { code: '+220', country: 'GM', name: 'Gambie' },
  { code: '+995', country: 'GE', name: 'Géorgie' },
  { code: '+233', country: 'GH', name: 'Ghana' },
  { code: '+30', country: 'GR', name: 'Grèce' },
  { code: '+1473', country: 'GD', name: 'Grenade' },
  { code: '+502', country: 'GT', name: 'Guatemala' },
  { code: '+224', country: 'GN', name: 'Guinée' },
  { code: '+245', country: 'GW', name: 'Guinée-Bissau' },
  { code: '+240', country: 'GQ', name: 'Guinée équatoriale' },
  { code: '+592', country: 'GY', name: 'Guyana' },
  { code: '+509', country: 'HT', name: 'Haïti' },
  { code: '+504', country: 'HN', name: 'Honduras' },
  { code: '+36', country: 'HU', name: 'Hongrie' },
  { code: '+91', country: 'IN', name: 'Inde' },
  { code: '+62', country: 'ID', name: 'Indonésie' },
  { code: '+98', country: 'IR', name: 'Iran' },
  { code: '+964', country: 'IQ', name: 'Irak' },
  { code: '+353', country: 'IE', name: 'Irlande' },
  { code: '+354', country: 'IS', name: 'Islande' },
  { code: '+972', country: 'IL', name: 'Israël' },
  { code: '+39', country: 'IT', name: 'Italie' },
  { code: '+1876', country: 'JM', name: 'Jamaïque' },
  { code: '+81', country: 'JP', name: 'Japon' },
  { code: '+962', country: 'JO', name: 'Jordanie' },
  { code: '+7', country: 'KZ', name: 'Kazakhstan' },
  { code: '+254', country: 'KE', name: 'Kenya' },
  { code: '+996', country: 'KG', name: 'Kirghizistan' },
  { code: '+686', country: 'KI', name: 'Kiribati' },
  { code: '+965', country: 'KW', name: 'Koweït' },
  { code: '+856', country: 'LA', name: 'Laos' },
  { code: '+266', country: 'LS', name: 'Lesotho' },
  { code: '+371', country: 'LV', name: 'Lettonie' },
  { code: '+961', country: 'LB', name: 'Liban' },
  { code: '+231', country: 'LR', name: 'Liberia' },
  { code: '+218', country: 'LY', name: 'Libye' },
  { code: '+423', country: 'LI', name: 'Liechtenstein' },
  { code: '+370', country: 'LT', name: 'Lituanie' },
  { code: '+352', country: 'LU', name: 'Luxembourg' },
  { code: '+389', country: 'MK', name: 'Macédoine du Nord' },
  { code: '+261', country: 'MG', name: 'Madagascar' },
  { code: '+60', country: 'MY', name: 'Malaisie' },
  { code: '+265', country: 'MW', name: 'Malawi' },
  { code: '+960', country: 'MV', name: 'Maldives' },
  { code: '+223', country: 'ML', name: 'Mali' },
  { code: '+356', country: 'MT', name: 'Malte' },
  { code: '+212', country: 'MA', name: 'Maroc' },
  { code: '+692', country: 'MH', name: 'Marshall' },
  { code: '+222', country: 'MR', name: 'Mauritanie' },
  { code: '+230', country: 'MU', name: 'Maurice' },
  { code: '+52', country: 'MX', name: 'Mexique' },
  { code: '+691', country: 'FM', name: 'Micronésie' },
  { code: '+373', country: 'MD', name: 'Moldavie' },
  { code: '+377', country: 'MC', name: 'Monaco' },
  { code: '+976', country: 'MN', name: 'Mongolie' },
  { code: '+382', country: 'ME', name: 'Monténégro' },
  { code: '+258', country: 'MZ', name: 'Mozambique' },
  { code: '+95', country: 'MM', name: 'Myanmar' },
  { code: '+264', country: 'NA', name: 'Namibie' },
  { code: '+674', country: 'NR', name: 'Nauru' },
  { code: '+977', country: 'NP', name: 'Népal' },
  { code: '+505', country: 'NI', name: 'Nicaragua' },
  { code: '+227', country: 'NE', name: 'Niger' },
  { code: '+234', country: 'NG', name: 'Nigeria' },
  { code: '+47', country: 'NO', name: 'Norvège' },
  { code: '+64', country: 'NZ', name: 'Nouvelle-Zélande' },
  { code: '+968', country: 'OM', name: 'Oman' },
  { code: '+256', country: 'UG', name: 'Ouganda' },
  { code: '+998', country: 'UZ', name: 'Ouzbékistan' },
  { code: '+92', country: 'PK', name: 'Pakistan' },
  { code: '+680', country: 'PW', name: 'Palaos' },
  { code: '+507', country: 'PA', name: 'Panama' },
  { code: '+675', country: 'PG', name: 'Papouasie-Nouvelle-Guinée' },
  { code: '+595', country: 'PY', name: 'Paraguay' },
  { code: '+31', country: 'NL', name: 'Pays-Bas' },
  { code: '+51', country: 'PE', name: 'Pérou' },
  { code: '+63', country: 'PH', name: 'Philippines' },
  { code: '+48', country: 'PL', name: 'Pologne' },
  { code: '+351', country: 'PT', name: 'Portugal' },
  { code: '+974', country: 'QA', name: 'Qatar' },
  { code: '+40', country: 'RO', name: 'Roumanie' },
  { code: '+44', country: 'GB', name: 'Royaume-Uni' },
  { code: '+7', country: 'RU', name: 'Russie' },
  { code: '+250', country: 'RW', name: 'Rwanda' },
  { code: '+1869', country: 'KN', name: 'Saint-Christophe-et-Niévès' },
  { code: '+1758', country: 'LC', name: 'Sainte-Lucie' },
  { code: '+378', country: 'SM', name: 'Saint-Marin' },
  { code: '+1784', country: 'VC', name: 'Saint-Vincent-et-les-Grenadines' },
  { code: '+677', country: 'SB', name: 'Salomon' },
  { code: '+503', country: 'SV', name: 'Salvador' },
  { code: '+685', country: 'WS', name: 'Samoa' },
  { code: '+239', country: 'ST', name: 'Sao Tomé-et-Principe' },
  { code: '+221', country: 'SN', name: 'Sénégal' },
  { code: '+381', country: 'RS', name: 'Serbie' },
  { code: '+248', country: 'SC', name: 'Seychelles' },
  { code: '+232', country: 'SL', name: 'Sierra Leone' },
  { code: '+65', country: 'SG', name: 'Singapour' },
  { code: '+421', country: 'SK', name: 'Slovaquie' },
  { code: '+386', country: 'SI', name: 'Slovénie' },
  { code: '+252', country: 'SO', name: 'Somalie' },
  { code: '+249', country: 'SD', name: 'Soudan' },
  { code: '+211', country: 'SS', name: 'Soudan du Sud' },
  { code: '+94', country: 'LK', name: 'Sri Lanka' },
  { code: '+46', country: 'SE', name: 'Suède' },
  { code: '+41', country: 'CH', name: 'Suisse' },
  { code: '+597', country: 'SR', name: 'Suriname' },
  { code: '+963', country: 'SY', name: 'Syrie' },
  { code: '+992', country: 'TJ', name: 'Tadjikistan' },
  { code: '+255', country: 'TZ', name: 'Tanzanie' },
  { code: '+66', country: 'TH', name: 'Thaïlande' },
  { code: '+670', country: 'TL', name: 'Timor oriental' },
  { code: '+228', country: 'TG', name: 'Togo' },
  { code: '+676', country: 'TO', name: 'Tonga' },
  { code: '+1868', country: 'TT', name: 'Trinité-et-Tobago' },
  { code: '+216', country: 'TN', name: 'Tunisie' },
  { code: '+993', country: 'TM', name: 'Turkménistan' },
  { code: '+90', country: 'TR', name: 'Turquie' },
  { code: '+688', country: 'TV', name: 'Tuvalu' },
  { code: '+380', country: 'UA', name: 'Ukraine' },
  { code: '+598', country: 'UY', name: 'Uruguay' },
  { code: '+678', country: 'VU', name: 'Vanuatu' },
  { code: '+39', country: 'VA', name: 'Vatican' },
  { code: '+58', country: 'VE', name: 'Venezuela' },
  { code: '+84', country: 'VN', name: 'Viêt Nam' },
  { code: '+967', country: 'YE', name: 'Yémen' },
  { code: '+260', country: 'ZM', name: 'Zambie' },
  { code: '+263', country: 'ZW', name: 'Zimbabwe' },
];

// Trier par ordre alphabétique du nom
const COUNTRIES = ALL_COUNTRIES.sort((a, b) => a.name.localeCompare(b.name, 'fr'));

// Trouver le Maroc pour le définir par défaut
const DEFAULT_COUNTRY = COUNTRIES.find(c => c.country === 'MA') || COUNTRIES[0];

// Map des émojis de drapeaux pour tous les pays
const FLAG_EMOJIS = {
  'AF': '🇦🇫', 'ZA': '🇿🇦', 'AL': '🇦🇱', 'DZ': '🇩🇿', 'DE': '🇩🇪', 'AD': '🇦🇩',
  'AO': '🇦🇴', 'AG': '🇦🇬', 'SA': '🇸🇦', 'AR': '🇦🇷', 'AM': '🇦🇲', 'AU': '🇦🇺',
  'AT': '🇦🇹', 'AZ': '🇦🇿', 'BS': '🇧🇸', 'BH': '🇧🇭', 'BD': '🇧🇩', 'BB': '🇧🇧',
  'BE': '🇧🇪', 'BZ': '🇧🇿', 'BJ': '🇧🇯', 'BT': '🇧🇹', 'BY': '🇧🇾', 'BO': '🇧🇴',
  'BA': '🇧🇦', 'BW': '🇧🇼', 'BR': '🇧🇷', 'BN': '🇧🇳', 'BG': '🇧🇬', 'BF': '🇧🇫',
  'BI': '🇧🇮', 'KH': '🇰🇭', 'CM': '🇨🇲', 'CA': '🇨🇦', 'CV': '🇨🇻', 'CF': '🇨🇫',
  'TD': '🇹🇩', 'CL': '🇨🇱', 'CN': '🇨🇳', 'CO': '🇨🇴', 'KM': '🇰🇲', 'CG': '🇨🇬',
  'CD': '🇨🇩', 'KP': '🇰🇵', 'KR': '🇰🇷', 'CR': '🇨🇷', 'CI': '🇨🇮', 'HR': '🇭🇷',
  'CU': '🇨🇺', 'CY': '🇨🇾', 'CZ': '🇨🇿', 'DK': '🇩🇰', 'DJ': '🇩🇯', 'DM': '🇩🇲',
  'EG': '🇪🇬', 'AE': '🇦🇪', 'EC': '🇪🇨', 'ER': '🇪🇷', 'ES': '🇪🇸', 'EE': '🇪🇪',
  'SZ': '🇸🇿', 'US': '🇺🇸', 'ET': '🇪🇹', 'FJ': '🇫🇯', 'FI': '🇫🇮', 'FR': '🇫🇷',
  'GA': '🇬🇦', 'GM': '🇬🇲', 'GE': '🇬🇪', 'GH': '🇬🇭', 'GR': '🇬🇷', 'GD': '🇬🇩',
  'GT': '🇬🇹', 'GN': '🇬🇳', 'GW': '🇬🇼', 'GQ': '🇬🇶', 'GY': '🇬🇾', 'HT': '🇭🇹',
  'HN': '🇭🇳', 'HU': '🇭🇺', 'IN': '🇮🇳', 'ID': '🇮🇩', 'IR': '🇮🇷', 'IQ': '🇮🇶',
  'IE': '🇮🇪', 'IS': '🇮🇸', 'IL': '🇮🇱', 'IT': '🇮🇹', 'JM': '🇯🇲', 'JP': '🇯🇵',
  'JO': '🇯🇴', 'KZ': '🇰🇿', 'KE': '🇰🇪', 'KG': '🇰🇬', 'KI': '🇰🇮', 'KW': '🇰🇼',
  'LA': '🇱🇦', 'LS': '🇱🇸', 'LV': '🇱🇻', 'LB': '🇱🇧', 'LR': '🇱🇷', 'LY': '🇱🇾',
  'LI': '🇱🇮', 'LT': '🇱🇹', 'LU': '🇱🇺', 'MK': '🇲🇰', 'MG': '🇲🇬', 'MY': '🇲🇾',
  'MW': '🇲🇼', 'MV': '🇲🇻', 'ML': '🇲🇱', 'MT': '🇲🇹', 'MA': '🇲🇦', 'MH': '🇲🇭',
  'MR': '🇲🇷', 'MU': '🇲🇺', 'MX': '🇲🇽', 'FM': '🇫🇲', 'MD': '🇲🇩', 'MC': '🇲🇨',
  'MN': '🇲🇳', 'ME': '🇲🇪', 'MZ': '🇲🇿', 'MM': '🇲🇲', 'NA': '🇳🇦', 'NR': '🇳🇷',
  'NP': '🇳🇵', 'NI': '🇳🇮', 'NE': '🇳🇪', 'NG': '🇳🇬', 'NO': '🇳🇴', 'NZ': '🇳🇿',
  'OM': '🇴🇲', 'UG': '🇺🇬', 'UZ': '🇺🇿', 'PK': '🇵🇰', 'PW': '🇵🇼', 'PA': '🇵🇦',
  'PG': '🇵🇬', 'PY': '🇵🇾', 'NL': '🇳🇱', 'PE': '🇵🇪', 'PH': '🇵🇭', 'PL': '🇵🇱',
  'PT': '🇵🇹', 'QA': '🇶🇦', 'RO': '🇷🇴', 'GB': '🇬🇧', 'RU': '🇷🇺', 'RW': '🇷🇼',
  'KN': '🇰🇳', 'LC': '🇱🇨', 'SM': '🇸🇲', 'VC': '🇻🇨', 'SB': '🇸🇧', 'SV': '🇸🇻',
  'WS': '🇼🇸', 'ST': '🇸🇹', 'SN': '🇸🇳', 'RS': '🇷🇸', 'SC': '🇸🇨', 'SL': '🇸🇱',
  'SG': '🇸🇬', 'SK': '🇸🇰', 'SI': '🇸🇮', 'SO': '🇸🇴', 'SD': '🇸🇩', 'SS': '🇸🇸',
  'LK': '🇱🇰', 'SE': '🇸🇪', 'CH': '🇨🇭', 'SR': '🇸🇷', 'SY': '🇸🇾', 'TJ': '🇹🇯',
  'TZ': '🇹🇿', 'TH': '🇹🇭', 'TL': '🇹🇱', 'TG': '🇹🇬', 'TO': '🇹🇴', 'TT': '🇹🇹',
  'TN': '🇹🇳', 'TM': '🇹🇲', 'TR': '🇹🇷', 'TV': '🇹🇻', 'UA': '🇺🇦', 'UY': '🇺🇾',
  'VU': '🇻🇺', 'VA': '🇻🇦', 'VE': '🇻🇪', 'VN': '🇻🇳', 'YE': '🇾🇪', 'ZM': '🇿🇲',
  'ZW': '🇿🇼'
};

// Composant pour afficher le drapeau (utilise les SVG en priorité, puis émojis)
const CountryFlag = ({ countryCode, className = '' }) => {
  const FlagComponent = FLAG_COMPONENTS[countryCode];
  const flagEmoji = FLAG_EMOJIS[countryCode];
  
  // Si le composant SVG est disponible, l'utiliser
  if (FlagComponent) {
    return (
      <FlagComponent 
        className={className} 
        style={{ 
          width: '24px', 
          height: '18px', 
          objectFit: 'cover',
          borderRadius: '3px',
          display: 'block',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
        }} 
      />
    );
  }
  
  // Sinon, utiliser l'émoji avec un style plus visible
  if (flagEmoji) {
    return (
      <span 
        className={`country-flag ${className}`} 
        role="img" 
        aria-label={`Drapeau ${countryCode}`}
        style={{ 
          fontSize: '20px', 
          lineHeight: '1',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '18px',
          textAlign: 'center',
          verticalAlign: 'middle',
          fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji, sans-serif',
          userSelect: 'none',
          overflow: 'hidden',
          borderRadius: '3px',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
        }}
        title={countryCode}
      >
        {flagEmoji}
      </span>
    );
  }
  
  // Fallback : afficher le code pays
  return (
    <span 
      className={`text-xs font-bold text-gray-600 ${className}`}
      style={{ 
        display: 'inline-block',
        width: '24px',
        height: '18px',
        textAlign: 'center',
        lineHeight: '18px'
      }}
    >
      {countryCode}
    </span>
  );
};

const PhoneInput = forwardRef(({ value, onChange, onBlur, error, placeholder = '6 12 34 56 78', highlight = false, phoneError = false }, ref) => {
  const [selectedCountry, setSelectedCountry] = useState(DEFAULT_COUNTRY);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fermer le dropdown au clic extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Initialiser avec la valeur si elle existe
  useEffect(() => {
    if (value) {
      // Si value contient le code pays, l'extraire
      const country = COUNTRIES.find(c => value.startsWith(c.code));
      if (country) {
        setSelectedCountry(country);
        setPhoneNumber(value.replace(country.code, '').trim());
      } else {
        setPhoneNumber(value);
      }
    }
  }, [value]);

  const handlePhoneChange = (e) => {
    const newValue = e.target.value.replace(/\D/g, ''); // Garder seulement les chiffres
    setPhoneNumber(newValue);
    
    // Appeler onChange avec le code pays + numéro
    if (onChange) {
      const fullNumber = selectedCountry.code + newValue;
      onChange({
        target: {
          name: 'phoneNumber',
          value: fullNumber,
        },
      });
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
    
    // Mettre à jour la valeur complète
    if (onChange) {
      const fullNumber = country.code + phoneNumber;
      onChange({
        target: {
          name: 'phoneNumber',
          value: fullNumber,
        },
      });
    }
  };

  return (
    <div className={`relative ${highlight ? 'ring-2 ring-orange-200 rounded-xl p-1' : ''}`}>
      <div className="flex">
        {/* Sélecteur de pays */}
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className={`flex items-center gap-2 px-3 py-2.5 rounded-l-xl border-r ${
              phoneError
                ? 'border-red-300 bg-red-50' 
                : error
                  ? 'border-red-500 bg-red-50'
                  : highlight 
                    ? 'border-orange-500 bg-orange-50' 
                    : 'border-gray-300 bg-gray-50'
            } hover:bg-gray-100 transition focus:outline-none focus:ring-2 focus:ring-[#27489E]/20`}
          >
            <div className="flex-shrink-0" style={{ width: '24px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CountryFlag 
                countryCode={selectedCountry.country} 
                className=""
              />
            </div>
            <span className="text-sm font-medium text-gray-700">{selectedCountry.code}</span>
            <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          {/* Dropdown des pays */}
          {isDropdownOpen && (
            <div className="absolute top-full left-0 mt-1 w-72 bg-white border border-gray-200 rounded-xl shadow-lg z-50 max-h-96 overflow-y-auto">
              {COUNTRIES.map((country) => (
                <button
                  key={country.code}
                  type="button"
                  onClick={() => handleCountrySelect(country)}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition ${
                    selectedCountry.code === country.code ? 'bg-[#27489E]/5' : ''
                  }`}
                >
                  <div className="flex-shrink-0" style={{ width: '24px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CountryFlag 
                      countryCode={country.country} 
                      className=""
                    />
                  </div>
                  <div className="flex-1 text-left min-w-0">
                    <div className="text-sm font-medium text-gray-700 truncate">{country.name}</div>
                    <div className="text-xs text-gray-500">{country.code}</div>
                  </div>
                  {selectedCountry.code === country.code && (
                    <div className="w-2 h-2 rounded-full bg-[#27489E] flex-shrink-0"></div>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Input téléphone */}
        <div className="flex-1 relative">
          <Phone className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 ${
            phoneError ? 'text-red-400' : 'text-gray-400'
          }`} />
          <input
            ref={ref}
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            onBlur={onBlur}
            placeholder={placeholder}
            className={`w-full pl-11 ${phoneError ? 'pr-10' : 'pr-4'} py-2.5 rounded-r-xl border transition-colors duration-200 ${
              phoneError
                ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500 bg-red-50'
                : error
                  ? 'border-red-500 bg-red-50'
                  : highlight 
                    ? 'border-orange-500 bg-orange-50' 
                    : 'border-gray-300 focus:border-[#27489E] focus:ring-[#27489E]'
            } focus:ring-2 focus:ring-[#27489E]/20 outline-none text-sm`}
          />
          {/* Icône d'alerte (seulement si phoneError) */}
          {phoneError && (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <AlertCircle className="h-5 w-5 text-red-500" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
